import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  cardContainer: theme => ({
    marginBottom: 16,
    height: 200,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.colors.cardBackgroundColor,
    borderRadius: 6,
    shadowColor: 'rgba(0, 0, 0, 0.16)',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowRadius: 6,
    shadowOpacity: 1,
    elevation: 2,
  }),
  cardIcon: {
    marginBottom: 10,
  },
  cardText: {
    textAlign: 'center',
    marginBottom: 17,
    fontSize: 16,
    lineHeight: 20,
    width: '80%',
  },
  scanButton: {
    width: '90%',
  },
});
